import {
  encodeURLParameter1u3y18ab0iker as encodeURLParameter,
  decodeURLQueryComponent1psnpw5x5jp3h as decodeURLQueryComponent,
  encodeURLParameterValueqlj48e6qtqd4 as encodeURLParameterValue,
} from './Codecs.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { toSet2orjxp16sotqu as toSet } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { ParametersBuilder1ry9ntvvg567r as ParametersBuilder } from './Parameters.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var UrlDecodedParametersBuilderClass;
function UrlDecodedParametersBuilder() {
  if (UrlDecodedParametersBuilderClass === VOID) {
    class $ {
      constructor(encodedParametersBuilder) {
        this.p55_1 = encodedParametersBuilder;
        this.q55_1 = this.p55_1.b4o();
      }
      c37() {
        return decodeParameters(this.p55_1);
      }
      b4o() {
        return this.q55_1;
      }
      c4o(name) {
        var tmp0_safe_receiver = this.p55_1.c4o(encodeURLParameter(name));
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.collections.map' call
          // Inline function 'kotlin.collections.mapTo' call
          var destination = ArrayList().m2(collectionSizeOrDefault(tmp0_safe_receiver, 10));
          var _iterator__ex2g4s = tmp0_safe_receiver.u1();
          while (_iterator__ex2g4s.v1()) {
            var item = _iterator__ex2g4s.w1();
            var tmp$ret$0 = decodeURLQueryComponent(item, VOID, VOID, true);
            destination.n2(tmp$ret$0);
          }
          tmp = destination;
        }
        return tmp;
      }
      d4o(name) {
        return this.p55_1.d4o(encodeURLParameter(name));
      }
      e4o() {
        // Inline function 'kotlin.collections.map' call
        var this_0 = this.p55_1.e4o();
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().m2(collectionSizeOrDefault(this_0, 10));
        var _iterator__ex2g4s = this_0.u1();
        while (_iterator__ex2g4s.v1()) {
          var item = _iterator__ex2g4s.w1();
          var tmp$ret$0 = decodeURLQueryComponent(item);
          destination.n2(tmp$ret$0);
        }
        return toSet(destination);
      }
      s1() {
        return this.p55_1.s1();
      }
      w4n() {
        return decodeParameters(this.p55_1).w4n();
      }
      h4o(name, value) {
        return this.p55_1.h4o(encodeURLParameter(name), encodeURLParameterValue(value));
      }
      i4o(stringValues) {
        return appendAllEncoded(this.p55_1, stringValues);
      }
      x4n(name, values) {
        var tmp = encodeURLParameter(name);
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().m2(collectionSizeOrDefault(values, 10));
        var _iterator__ex2g4s = values.u1();
        while (_iterator__ex2g4s.v1()) {
          var item = _iterator__ex2g4s.w1();
          var tmp$ret$0 = encodeURLParameterValue(item);
          destination.n2(tmp$ret$0);
        }
        return this.p55_1.x4n(tmp, destination);
      }
      f5() {
        return this.p55_1.f5();
      }
    }
    initMetadataForClass($, 'UrlDecodedParametersBuilder');
    UrlDecodedParametersBuilderClass = $;
  }
  return UrlDecodedParametersBuilderClass;
}
function encodeParameters(parameters) {
  // Inline function 'kotlin.apply' call
  var this_0 = ParametersBuilder();
  appendAllEncoded(this_0, parameters);
  return this_0;
}
function decodeParameters(parameters) {
  // Inline function 'kotlin.apply' call
  var this_0 = ParametersBuilder();
  appendAllDecoded(this_0, parameters);
  return this_0.c37();
}
function appendAllEncoded(_this__u8e3s4, parameters) {
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = parameters.e4o().u1();
  while (_iterator__ex2g4s.v1()) {
    var element = _iterator__ex2g4s.w1();
    var tmp0_elvis_lhs = parameters.c4o(element);
    var values = tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
    var tmp = encodeURLParameter(element);
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList().m2(collectionSizeOrDefault(values, 10));
    var _iterator__ex2g4s_0 = values.u1();
    while (_iterator__ex2g4s_0.v1()) {
      var item = _iterator__ex2g4s_0.w1();
      var tmp$ret$0 = encodeURLParameterValue(item);
      destination.n2(tmp$ret$0);
    }
    _this__u8e3s4.x4n(tmp, destination);
  }
}
function appendAllDecoded(_this__u8e3s4, parameters) {
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = parameters.e4o().u1();
  while (_iterator__ex2g4s.v1()) {
    var element = _iterator__ex2g4s.w1();
    var tmp0_elvis_lhs = parameters.c4o(element);
    var values = tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
    var tmp = decodeURLQueryComponent(element);
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList().m2(collectionSizeOrDefault(values, 10));
    var _iterator__ex2g4s_0 = values.u1();
    while (_iterator__ex2g4s_0.v1()) {
      var item = _iterator__ex2g4s_0.w1();
      var tmp$ret$0 = decodeURLQueryComponent(item, VOID, VOID, true);
      destination.n2(tmp$ret$0);
    }
    _this__u8e3s4.x4n(tmp, destination);
  }
}
//region block: exports
export {
  UrlDecodedParametersBuilder as UrlDecodedParametersBuilder18hwlye3pykgz,
  encodeParameters as encodeParameters1kx5voquz3xxo,
};
//endregion

//# sourceMappingURL=UrlDecodedParametersBuilder.mjs.map
